import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class ComponentSettingsService {

  public footerVisible: boolean;

  constructor() { }
}
